<template>
  <el-row :gutter="10">
    <el-col :span="2">
      <strong>Legenda:</strong>
    </el-col>
    <el-col :span="3">
      <el-tag class="Green">
        Ejecutado ( <strong>{{ PaymentExecutedProp }}</strong> )</el-tag
      >
    </el-col>
    <el-col :span="4">
      <el-tag class="Red">
        Vencido Sin Ejecutar (
        <strong>{{ PaymentOutdatedProp }}</strong> )</el-tag
      >
    </el-col>
    <el-col :span="4">
      <el-tag class="Yellow">
        Mes Actual Sin Vencer (
        <strong>{{ ActualMonthpaymentOnTimeProp }}</strong> )</el-tag
      >
    </el-col>
    <el-col :span="4">
      <el-tag>
        Otros meses Sin Vencer (
        <strong>{{ OtherMonthPaymentOnTimeProp }}</strong> )</el-tag
      >
    </el-col>
  </el-row>
</template>

<script>
import { formatterMoney } from "@/utils";

export default {
  name: "InvoiceAndPaymentTotalCards",
  props: {
    TabSelected: {
      type: String,
      default: "",
      required: true
    },
    ReportUpdated: {
      type: Boolean,
      default: false,
      required: false
    },
    YearSelected: {
      type: Number,
      default: 0,
      required: false
    },
    MonthSelected: {
      type: Number,
      default: 0,
      required: false
    },
    PaymentTypeSelected: {
      type: Number,
      default: 0,
      required: false
    },
    PaymentSelected: {
      type: String,
      default: "",
      required: false
    },
    ExecutionSelected: {
      type: String,
      default: null,
      required: false
    },
    InvoiceType: {
      type: String,
      default: "",
      required: false
    },
    WeekSelected: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      paymentExecuted: 0,
      paymentOutdated: 0,
      actualMonthpaymentOnTime: 0,
      otherMonthaymentOnTime: 0
    };
  },

  mounted() {
    this.GetTotalCardsData();
  },
  computed: {
    ActualTabValue() {
      return this.TabSelected;
    },
    YearFilter() {
      return this.YearSelected;
    },
    MonthFilter() {
      return this.MonthSelected;
    },
    PaymentTypeFilter() {
      return this.PaymentTypeSelected;
    },
    PaymenFilter() {
      return this.PaymentSelected;
    },
    ExecutionFilter() {
      return this.ExecutionSelected;
    },
    InvoiceTypeFilter() {
      return this.InvoiceType;
    },
    WeekSelectedFilter() {
      return this.WeekSelected;
    },
    ReportGotUpdated() {
      return this.ReportUpdated;
    },
    PaymentExecutedProp() {
      return this.formatterMoney(this.paymentExecuted);
    },
    PaymentOutdatedProp() {
      return this.formatterMoney(this.paymentOutdated);
    },
    ActualMonthpaymentOnTimeProp() {
      return this.formatterMoney(this.actualMonthpaymentOnTime);
    },
    OtherMonthPaymentOnTimeProp() {
      return this.formatterMoney(this.otherMonthaymentOnTime);
    }
  },

  methods: {
    formatterMoney,
    async GetTotalCardsData() {
      const body = {
        params: {
          Year: this.YearFilter,
          Month: this.MonthFilter,
          PaymentName: this.PaymenFilter,
          PaymentType: this.PaymentTypeFilter,
          isExecuted: this.ExecutionFilter,
          invoiceType: this.InvoiceTypeFilter,
          WeekSelected: this.WeekSelectedFilter
        }
      };

      await this.$http
        .get(
          "/api/CalendarioFinanza/GetInvoicesAndPaymentsTotalCardsReport",
          body
        )
        .then((resp) => {
          this.SetCardData(resp.data);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {});
    },
    SetCardData(cardsData) {
      this.paymentExecuted = cardsData.filter(
        (cd) => cd.Description === "Ejecutado"
      )[0].Total;
      this.paymentOutdated = cardsData.filter(
        (cd) => cd.Description === "Retrazado"
      )[0].Total;
      this.actualMonthpaymentOnTime = cardsData.filter(
        (cd) => cd.Description === "Mes Actual Al Dia"
      )[0].Total;
      this.otherMonthaymentOnTime = cardsData.filter(
        (cd) => cd.Description === "Otros Meses Al Dia"
      )[0].Total;
    }
  },
  watch: {
    ActualTabValue(val) {
      if (val === "report") this.GetTotalCardsData();
    },
    ReportGotUpdated() {
      this.GetTotalCardsData();
    },
    YearFilter() {
      this.GetTotalCardsData();
    },
    MonthFilter() {
      this.GetTotalCardsData();
    },
    PaymentTypeFilter() {
      this.GetTotalCardsData();
    },
    ExecutionFilter() {
      this.GetTotalCardsData();
    },
    InvoiceTypeFilter() {
      this.GetTotalCardsData();
    },
    WeekSelectedFilter() {
      this.GetTotalCardsData();
    },
    PaymenFilter() {
      this.GetTotalCardsData();
    }
  }
};
</script>

<style scoped>
.Bold {
  font-weight: bold;
}
.Blue {
  color: blue;
}
.Red {
  color: darkred;
  background-color: lightsalmon;
  border-color: darkred;
}
.Green {
  color: darkgreen;
  background-color: lightgreen;
  border-color: darkgreen;
}
.Yellow {
  color: darkorange;
  background-color: lightgoldenrodyellow;
  border-color: darkorange;
}
</style>
